import React from "react";

/* Official AMS Travel logo files (public/brand). */
export const LOGO = {
  dark: "/brand/ams-logo-dark.webp",
  light: "/brand/ams-logo-light.webp",
  mark: "/brand/ams-mark.webp",
};

export const Logo = ({ light = false, className = "h-9 md:h-10" }) => (
  <img
    src={light ? LOGO.light : LOGO.dark}
    alt="AMS Travel"
    width="900"
    height="354"
    className={`w-auto select-none ${className}`}
    style={{ transition: "opacity .3s ease" }}
    data-testid="brand-logo"
  />
);

export const LogoStacked = ({ light = false, className = "h-16 md:h-20" }) => (
  <img src={light ? LOGO.light : LOGO.dark} alt="AMS Travel" width="900" height="354" className={`w-auto select-none ${className}`} data-testid="brand-logo-stacked" />
);

export const LogoMark = ({ className = "h-8" }) => (
  <img src={LOGO.mark} alt="" aria-hidden="true" width="900" height="573" className={`w-auto select-none ${className}`} data-testid="brand-mark" />
);
